// extracted by mini-css-extract-plugin
export default {"submitButton":"SaveChangesBtn_submitButton__b0iHl"};